import { SimpleATHandler, SimpleAVHandler } from '../types/@types/sl-v-types';
export type SelectionProxyListener = SimpleAVHandler<{ proxy: SelectionProxy, properties: Array<string> }>;
export type SelectionProxyListeners = Record<string, SelectionProxyListener>;

export class SelectionProxy {
  private _selections: any = {}
  private _listeners: SelectionProxyListeners = {}
  private _updating: boolean = false;

  private _updated: boolean = false;
  private _updates: Array<string> = [];
  ToggleUpdating(isIt?: boolean) {
    if(this._updating === undefined ) this._updating = false;
    const wasIt = this._updating;
    this._updating = (isIt === undefined) ? !this._updating : isIt;
    if (wasIt && !this._updating) {
      if (this._updated) this.NotifyChangeListeners();
    }
    this._updates = [];
    this._updated = false;
  }
  AddProperty(selectionName: string, defaultValue: any = null) {
    this._selections[selectionName] = defaultValue;
  }
  SetProperty(selectionName: string, value: any) {
    if (this._selections[selectionName] === value) return;
    this._selections[selectionName] = value;
    if(this._updates.indexOf(selectionName) < 0) this._updates.push(selectionName);
    this._updated = true;
    this.NotifyChangeListeners();
  }
  GetProperty(selectionName): any {
    return this._selections[selectionName];
  }
  NotifyChangeListeners() {
    if (this._updating === true) return;
    Object.entries(this._listeners).forEach(([key, listener]) => {
      listener({ proxy: this, properties: this._updates });
    });
  }
  RegisterListener(listenerId, listener: SelectionProxyListener) {
    this._listeners[listenerId] = listener;
  }
  UnRegisterListener(listenerId) {
    delete this._listeners[listenerId];
  }
}
